import ApplicationsSortingUtility from "./ApplicationsSortingUtility";
import ApplicationItem from "@p1s/p1s-common-react/entities/ApplicationItem";

class DataParserHelper {

    // Extracts Users (app state) from raw users (db state)
    getUserFromRaw(rawUser) {
        return {
            firstName: rawUser.Contact.FirstName,
            lastName: rawUser.Contact.LastName,
            userName: this.formatUserName(rawUser),
            email: rawUser.Contact.Email,
            phone: rawUser.Contact.Phone,
            siteId: rawUser.Site,
            userId: rawUser.Id,
            orgId: rawUser.OrgId,
            isActive: rawUser.IsActive,
            userProducts: this.getUserProducts(rawUser),
            team: rawUser.Team.Name,
            lastLogin: rawUser.LastLoginDateTime,
            role: rawUser.Role,
            login: rawUser.Login,
            isLocked: rawUser.IsLocked,
            isPasswordExpired: rawUser.IsPasswordExpired,
            orgName: rawUser.OrganizationName
        };
    }

    formatUserName(rawUser) {
        var separator = ", ";
        if (rawUser.Contact.LastName == null
            || rawUser.Contact.FirstName == null
            || rawUser.Contact.LastName.trim() === ""
            || rawUser.Contact.FirstName.trim() === "") {
            separator = "";
        }
        return rawUser.Contact.LastName + separator + rawUser.Contact.FirstName;
    }

    // Extracts rawUser (db state) from user (app state)
    getRawUser(user) {
        return {
            UserId: user.userId,
            FirstName: user.firstName,
            LastName: user.lastName,
            Email: user.email,
            Phone: user.phone,
            Password: user.newPassword,
            OrgId: user.orgId
        };
    }

    getUsersFromRaw(rawUsers) {
        return rawUsers.map(u => this.getUserFromRaw(u));
    }

    getUserProducts(rawUser) {
        var userProducts = [];
        rawUser.UserProducts.forEach(function (up) {
            var product = {
                roleId: up.RoleId,
                roleName: up.RoleName,
                productId: up.ProductId,
                productName: up.ProductName,
                url: up.Url
            };
            userProducts.push(product);
        });
        return userProducts;
    }

    getAvailableApplicationFromRaw(rawApplication) {
        return new ApplicationItem(rawApplication);
    }

    getAvailableApplicationsFromRaw(rawApplications) {
        return rawApplications.map(a => this.getAvailableApplicationFromRaw(a)).sort(ApplicationsSortingUtility.sortByApplicationName);
    }
}

export default new DataParserHelper;
